// generated by the plop

import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { Navigate, RouterNavigated } from '@ngxs/router-plugin';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, patch, updateItem } from '@ngxs/store/operators';
import { cloneDeep } from 'lodash';
import { ChangeTabIndex, CloseTabSuccess, routesMap, TabModel } from 'shared';
import { AddTab, CloseTab, ConfirmCloseTab, UpdateTabLabel } from './tabs-nav.actions';
import { TABS_NAV_STATE_DEFAULT, TabsNavStateModel } from './tabs-nav.model';

@State({ name: 'tabs_nav', defaults: TABS_NAV_STATE_DEFAULT })
@Injectable()
export class TabsNavState {

  constructor() {
  }

  @Selector()
  static currentTab(state: TabsNavStateModel): TabModel {
    return state.tabs?.[state.tabIndexSelected] || null;
  }

  @Selector()
  static tabs(state: TabsNavStateModel): TabsNavStateModel['tabs'] {
    return state.tabs;
  }

  @Selector()
  static tabsQueue(state: TabsNavStateModel): TabsNavStateModel['tabsQueue'] {
    return state.tabsQueue;
  }

  @Selector()
  static tabIndexSelected(state: TabsNavStateModel): TabsNavStateModel['tabIndexSelected'] {
    return state.tabIndexSelected;
  }


  @Action(AddTab)
  addTab(ctx: StateContext<TabsNavStateModel>, { tab }: AddTab): void {
    const tabs = ctx.getState().tabs;
    if (!tabs.some(t => t.url === tab.url)) {
      const existTab = tabs.find(t => t.tabUUID === tab.tabUUID && (t.tabReplace && tab.tabReplace));
      if (existTab) {
        ctx.setState(patch({
          tabs: updateItem(t => t.tabUUID === existTab.tabUUID, tab)
        }));
      } else {
        ctx.setState(patch({
          tabs: append([tab])
        }));
      }
    }

    let tabsQueue = cloneDeep(ctx.getState().tabsQueue);
    tabsQueue = tabsQueue.filter(t => t.tabReplace ? (t.tabUUID !== tab.tabUUID) : (t.url !== tab.url));
    tabsQueue.push(tab);
    ctx.patchState({ tabsQueue });


    const tabIndexSelected = ctx.getState().tabs.findIndex(t => t.url === tab.url);
    ctx.patchState({ tabIndexSelected });
  }

  @Action(CloseTab)
  closeTab(ctx: StateContext<TabsNavStateModel>, { tab }: CloseTab): void {
    if (tab.isChanged) {
      const currentTab = ctx.getState().tabs.find(t => t.url === tab.url);
      ctx.dispatch(new ConfirmCloseTab(currentTab));
    } else {
      ctx.dispatch(new CloseTabSuccess(tab));
      let tabsQueue = cloneDeep(ctx.getState().tabsQueue);
      tabsQueue = tabsQueue.filter(t => t.url !== tab.url);

      const tabs = cloneDeep(ctx.getState().tabs);
      ctx.patchState({
        tabs: tabs.filter(t => t.url !== tab.url),
        tabsQueue
      });

      if (tabsQueue.length) {
        ctx.dispatch(new Navigate([tabsQueue[tabsQueue.length - 1].url]));
      } else {
        ctx.dispatch(new Navigate([routesMap.dashboard.getAbsolutePath]));
      }

      ctx.patchState({ tabIndexSelected: tabsQueue.length ? tabsQueue.length - 1 : null });
    }
  }


  @Action(RouterNavigated)
  selectedTab(ctx: StateContext<TabsNavStateModel>, { event }: RouterNavigated<any>) {
    const tabIndexSelected = ctx.getState().tabs.findIndex(t => t.url === event.url);
    ctx.patchState({ tabIndexSelected: tabIndexSelected === -1 ? null : tabIndexSelected });
  }

  @Action(UpdateTabLabel)
  updateTabLabel(ctx: StateContext<TabsNavStateModel>, { tab }: UpdateTabLabel): void {
    const tabs = ctx.getState().tabs;
    const index = tabs.findIndex(t => t.url === tab.url || t.tabUUID === tab.tabUUID);
    ctx.setState(patch(
      {
        tabs: updateItem(index, patch({
          label: tab.label ? tab.label : tabs[index]?.label,
          isChanged: tab.isChanged === undefined ? tabs[index]?.isChanged : tab.isChanged,
          id: tab.id ? tab.id : tabs[index]?.id,
          isValidData: tab.isValidData === undefined ? tabs[index]?.isValidData : tab.isValidData,
          canSaveForce: tab.canSaveForce,
          versionDifferent: tab.versionDifferent,
          isNew: tab.isNew === undefined ? tabs[index]?.isNew : tab.isNew
        }))
      }
    ));
  }

  @Action(ChangeTabIndex)
  changeTabIndex(ctx: StateContext<TabsNavStateModel>, { prevIndex, currentIndex }: ChangeTabIndex): void {
    const tabs = cloneDeep(ctx.getState().tabs);
    const currentTab = tabs[ctx.getState().tabIndexSelected];

    moveItemInArray(tabs, prevIndex, currentIndex);

    const selectedIndex = tabs.findIndex(t => t.url === currentTab.url);
    ctx.patchState({
      tabs,
      tabIndexSelected: selectedIndex
    });
  }
}


